import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { FavoriteButtonContainer } from './FavoriteButtonContainer';
import { updateFeatureProperties } from '../../actions/features';
import { toggleFeaturesActiveStatus } from '../../actions/newbuildingPolygon';
import { closeSearchResultsSidebar } from '../../actions/searchResults';
import { SidebarNewbuildingHeader } from '../../components/SidebarNewbuildingHeader';
import { selectActiveFeature, selectNewbuildingId, selectNewbuildingFicheringPlus } from '../../selectors/features';
import { selectActiveNewbuildingPolygon } from '../../selectors/newbuildingPolygons';
import { TThunkDispatch } from '../../types/redux';
import { trackCloseSidebar } from '../../utils/tracking';
import { useApplicationContext } from '../ApplicationContext';

const COMPARE_ENABLED_CONFIG = 'Newbuilding.Compare.Enabled';

export const SidebarNewbuildingHeaderContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const newbuildingId = useSelector(selectNewbuildingId);
  const isFicheringPlus = useSelector(selectNewbuildingFicheringPlus);
  const activeFeature = useSelector(selectActiveFeature);
  const { geohashIds } = useSelector(selectActiveNewbuildingPolygon);
  const isCompareEnabled = config.get<boolean>(COMPARE_ENABLED_CONFIG) || false;

  const dispatch = useDispatch<TThunkDispatch>();

  const handleClose = React.useCallback(() => {
    dispatch(closeSearchResultsSidebar());
    trackCloseSidebar(newbuildingId, isFicheringPlus);
    dispatch(toggleFeaturesActiveStatus({ geohashIds, isActive: false }));

    if (activeFeature) {
      dispatch(
        updateFeatureProperties({
          featureId: activeFeature.id,
          precision: activeFeature.precision,
          properties: { isActive: false, isHovered: false },
        }),
      );
    }
  }, [activeFeature, dispatch, newbuildingId, geohashIds, isFicheringPlus]);

  return (
    <SidebarNewbuildingHeader
      favoriteButton={isCompareEnabled ? null : <FavoriteButtonContainer />}
      isCompareEnabled={isCompareEnabled}
      onClose={handleClose}
    />
  );
};

SidebarNewbuildingHeaderContainer.displayName = 'SidebarNewbuildingHeaderContainer';
